import { createEntityAdapter } from '@reduxjs/toolkit';
import { Settings } from '@tests/types';

export const settingsAdapter = createEntityAdapter<Settings>();
